export const OkrsEN = {
    "okr": {
        "header": {
            "title": "List OKR Object",
            "titleAdd": "Create OKR Object",
            "titleUpdate": "Update OKR Object",
            "titleDetail": "Detail OKR Object",
            "generalInformation": "General Information"
        },
    }
}